import AddService from './Publication/Add';
import ChannelSelect from './ChannelSelect';
import Edit from './Edit';
import EditPlayer from './Publication/Player';
import EditService from './Publication/Edit';
import Initializing from './Initializing';
import Invalid from './Invalid';
import Incompatible from './Incompatible';
import Login from './Login';
import Main from './Main';
import Password from './Password';
import Playersite from './Playersite';
import Settings from './Settings';
import Wizard from './Edit/Wizard';

export default {
	AddService,
	Edit,
	EditPlayer,
	EditService,
	Initializing,
	Invalid,
	Incompatible,
	Login,
	Main,
	Playersite,
	Settings,
	Wizard,
	ChannelSelect,
	Password,
};
